import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    app
  },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    tenantId: state => state.user.tenantId,
    sidebarOpened: state => state.app.sidebarOpened,
    permissions: state => state.user.permissions,
    // 判断是否具备某权限；不传权限名即视为放行（如个人中心这类无需授权的页面）
    hasPermission: state => name => !name || state.user.permissions[name] === true
  }
})
